import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { CASE_STUDIES_SLUGS } from 'utils/constants';

const DefaultFooter = dynamic(() => import('./DefaultFooter'));

const Footer = () => {
  const { query: { project } } = useRouter();

  if (CASE_STUDIES_SLUGS.includes(project)) {
    return;
  }

  return <DefaultFooter />;
};

export default Footer;
